import { useRef } from 'react';
import { WidgetContainer } from '@/components/analytics/WidgetContainer';
import { LineChart } from '@/components/analytics/charts/LineChart';
import { useChartDimensions } from '@/hooks/useChartDimensions';
import type { ParticipationTrendData } from '@/types/analytics';
import styles from './ParticipationTrendsWidget.module.scss';

export interface ParticipationTrendsWidgetProps {
    data: ParticipationTrendData[] | null;
    isLoading?: boolean;
    error?: Error | null;
}

export function ParticipationTrendsWidget({ data, isLoading, error }: ParticipationTrendsWidgetProps) {
    const containerRef = useRef<HTMLDivElement>(null);
    const { width } = useChartDimensions(containerRef as any);

    const isEmpty = !data || data.length === 0;

    const chartSeries = data
        ? [
            {
                name: 'Questions',
                data: data.map((d) => ({
                    x: d.date,
                    y: d.questionsAnswered,
                })),
                color: 'var(--primary)',
            },
            {
                name: 'Sessions',
                data: data.map((d) => ({
                    x: d.date,
                    y: d.sessionsCompleted,
                })),
                color: 'var(--secondary)',
            },
        ]
        : [];

    return (
        <WidgetContainer
            title="Participation Trends"
            description="Volume of questions and sessions over time"
            isLoading={isLoading}
            error={error}
            isEmpty={isEmpty}
            emptyMessage="No participation data yet"
            size="medium"
        >
            <div ref={containerRef} className={styles.container}>
                {width > 0 && (
                    <LineChart
                        series={chartSeries}
                        width={width}
                        height={200}
                        animate
                        showDots
                    />
                )}
            </div>
        </WidgetContainer>
    );
}
